import { BookingStep, BookingStepName } from "types/bookingV2Types"

/**
 * Parameters for navigation between booking steps
 */
interface StepNavigationParams {
    /** List of available steps in the booking flow */
    availableSteps: BookingStepName[]
    /** Current step configuration */
    currentStep: BookingStep
    /** Previous step configuration or undefined if at first step */
    prevStep: BookingStep | undefined
    /** Next step configuration or undefined if at last step */
    nextStep: BookingStep | undefined
    /** Function to set the current step name */
    setCurrentStepName: (step: BookingStepName) => void
    /** Optional router for navigation to external pages */
    router?: any
    /** Optional event ID for building the checkout URL */
    eventId?: string
}

/**
 * Navigates to the next step in the booking flow
 * @param params Navigation parameters
 */
export const getNextStepAction = ({
    availableSteps,
    currentStep,
    nextStep,
    setCurrentStepName,
    router,
    eventId,
}: StepNavigationParams): void => {
    const currentStepIndex = availableSteps.indexOf(currentStep.name)

    // If next step is checkout, redirect to the checkout page instead
    if (
        nextStep &&
        nextStep.name === BookingStepName.CHECKOUT &&
        router &&
        eventId
    ) {
        router.push(`/events/${eventId}/book/checkout`)
        return
    }

    if (nextStep && currentStepIndex < availableSteps.length - 1) {
        setCurrentStepName(availableSteps[currentStepIndex + 1])
    }
}

/**
 * Navigates to the previous step in the booking flow
 * @param params Navigation parameters
 */
export const getPrevStepAction = ({
    availableSteps,
    currentStep,
    prevStep,
    setCurrentStepName,
}: StepNavigationParams): void => {
    const currentStepIndex = availableSteps.indexOf(currentStep.name)
    if (prevStep && currentStepIndex > 0) {
        setCurrentStepName(availableSteps[currentStepIndex - 1])
    }
}
